import { useState, useEffect } from 'react';

export const useKeyboardNavigation = (results, onResultClick, resultRefs, resultsContainerRef) => {
    const [selectedIndex, setSelectedIndex] = useState(-1);

    // פונקציה לגלילה חלקה לתוצאה הנבחרת
    const scrollToResult = (index) => {
        const element = resultRefs.current[index];
        if (!element || !resultsContainerRef.current) return;

        const container = resultsContainerRef.current;
        const elementTop = element.offsetTop;
        const elementBottom = elementTop + element.offsetHeight;
        const containerTop = container.scrollTop;
        const containerBottom = containerTop + container.offsetHeight;

        if (elementTop < containerTop) {
            container.scrollTo({
                top: elementTop - 8,
                behavior: 'smooth'
            });
        } else if (elementBottom > containerBottom) {
            container.scrollTo({
                top: elementBottom - container.offsetHeight + 8,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        setSelectedIndex(-1);
        resultRefs.current = results ? new Array(results.length).fill(null) : [];
    }, [results]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!results?.length) return;

            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    setSelectedIndex(prev => {
                        const next = prev < results.length - 1 ? prev + 1 : prev;
                        scrollToResult(next);
                        return next;
                    });
                    break;

                case 'ArrowUp':
                    e.preventDefault();
                    setSelectedIndex(prev => {
                        const next = prev > 0 ? prev - 1 : 0;
                        scrollToResult(next);
                        return next;
                    });
                    break;

                case 'Enter':
                    if (selectedIndex >= 0 && selectedIndex < results.length) {
                        e.preventDefault();
                        resultRefs.current[selectedIndex]?.click();
                    }
                    break;

                default:
                    break;
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [results, selectedIndex, onResultClick]);

    return { selectedIndex };
};
export default useKeyboardNavigation;